/**
 * `Ф2` / `Ф3` (кабинет): текст отказа сервера — как есть, без выдумки.
 *
 * Сервер возвращает причину в `error` (или `message`); если её нет, остаётся
 * общий текст. Показывать «что-то пошло не так» вместо названной причины —
 * значит скрыть от человека, что именно не принято.
 */
export function serverMessageOf(
  error: unknown,
  fallback = "Не удалось выполнить действие",
): string {
  const value = error as {
    response?: { data?: { error?: string; message?: string } };
    message?: string;
  };

  return (
    value?.response?.data?.error ||
    value?.response?.data?.message ||
    value?.message ||
    fallback
  );
}

/**
 * `E.4` (Ф2): сервер ответил `410` с `code: "history_expired"`.
 *
 * Возвращает срок, до которого история была доступна, иначе `null`. Отдельная
 * проверка нужна, чтобы не показывать «не удалось загрузить» там, где всё
 * исправно: история по своему месту закрыта сроком хранения.
 */
export function historyExpiredUntil(error: unknown): string | null {
  const value = error as {
    response?: {
      status?: number;
      data?: { code?: string; history_until?: string | null };
    };
  };

  const response = value?.response;

  if (!response) return null;
  if (response.data?.code !== "history_expired") return null;
  if (response.status !== undefined && response.status !== 410) return null;

  return response.data?.history_until ?? null;
}
